import { Col, Row } from 'react-bootstrap'
import { InputWithTokens } from '../../../../../../components/InputWithTokens/InputWithTokens'
import { SelectDropdown, SelectOption } from '../../../../../../components/SelectDropdown/SelectDropdown'
import { FieldDescriptor, FieldUpdateMode } from '../../../../../../models/Account'
import { MentionData } from '../../../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Nodes/MentionNode/MentionNode'
import { InputWithTokensElements } from '../../../../../../components/InputWithTokens/utils'
import { Button } from '../../../../../../components/Button/Button'

export type FieldMappingRow = {
  id: string
  descriptors: FieldDescriptor[]
}

export interface OutboundFieldMappingRowProps {
  objectMappingRow: FieldMappingRow
  inputTokenOptions: MentionData[]
  inputTokenElements: InputWithTokensElements[]
  onInputWithTokensChange: (parsedContents: InputWithTokensElements[], rowId: string) => void
  externalFieldOptions: SelectOption[]
  initialExternalField?: SelectOption | null
  handleExternalFieldSelect: (selected: SelectOption, rowId: string) => void
  isExternalFieldSelectLoading?: boolean
  handleRemoveRow: (rowId: string) => void
  fieldError?: string
  objectIsUpdatable: boolean
  initialFieldUpdateMode?: FieldUpdateMode
  onUpdateModeChange: (updateMode: FieldUpdateMode, rowId: string) => void
  updateModeChangeDisabled?: boolean
}

export const OutboundFieldMappingRow: React.FC<OutboundFieldMappingRowProps> = ({
  objectMappingRow,
  inputTokenOptions,
  inputTokenElements,
  onInputWithTokensChange,
  externalFieldOptions,
  initialExternalField = null,
  handleExternalFieldSelect,
  isExternalFieldSelectLoading = false,
  handleRemoveRow,
  fieldError,
  objectIsUpdatable,
  initialFieldUpdateMode = null,
  onUpdateModeChange,
  updateModeChangeDisabled = false,
}) => {
  const fieldUpdateModeOptions: SelectOption[] = [
    { id: FieldUpdateMode.APPEND, label: 'Append' },
    { id: FieldUpdateMode.PREPEND, label: 'Prepend' },
    { id: FieldUpdateMode.OVERWRITE, label: 'Overwrite' },
    { id: FieldUpdateMode.CREATE_ONLY, label: 'Create Only' },
  ]

  return (
    <Row key={objectMappingRow.id} className='mb-3 align-items-center'>
      <Col>
        <InputWithTokens
          options={inputTokenOptions}
          onChange={(parsedContents) => onInputWithTokensChange(parsedContents, objectMappingRow.id)}
          elements={inputTokenElements}
        />
        {fieldError && <div className='invalid-feedback d-block'>{fieldError || 'This field is required'}</div>}
      </Col>
      <Col className='d-flex align-items-center'>
        <i className='bi bi-arrow-right mx-3 zocks-text-gray-500 fs-5'></i>
        <div className='flex-grow-1'>
          <SelectDropdown
            searchable
            options={externalFieldOptions}
            initialSelectedOption={initialExternalField}
            placeholder='Select field'
            onOptionSelected={(selected) => handleExternalFieldSelect(selected, objectMappingRow.id)}
            loading={isExternalFieldSelectLoading}
          />
        </div>
        {objectIsUpdatable && (
          <div className='ms-2'>
            <SelectDropdown
              options={fieldUpdateModeOptions}
              initialSelectedOption={initialFieldUpdateMode ? fieldUpdateModeOptions.find((opt) => opt.id === initialFieldUpdateMode) || null : null}
              placeholder='Update mode'
              onOptionSelected={(selected) => {
                onUpdateModeChange(selected.id as FieldUpdateMode, objectMappingRow.id)
              }}
              disabled={updateModeChangeDisabled}
            />
          </div>
        )}
        <Button variant='primaryGhost' className='p-2 ms-2' onClick={() => handleRemoveRow(objectMappingRow.id)} title='Remove row'>
          <i className='bi bi-trash' />
        </Button>
      </Col>
    </Row>
  )
}
